import React, { useState, useEffect } from "react";
import axios from "axios";
import { GlobalSet } from "../../global/GlobalProvider";
import { useTranslation } from "react-i18next";

const BasicDatatable = () => {
  const { t } = useTranslation();
  const { CurrencySymbol } = GlobalSet();

  const [income, setIncome] = useState([]);

  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0,
  });

  const [loading, setLoading] = useState(false);

  /* API CALL */

  const fetchIncome = (page = 1) => {
    const selectedCurrency = localStorage.getItem("selectedCurrency");
    const auth_token = localStorage.getItem("auth_token");

    if (!auth_token) return;

    setLoading(true);

    axios
      .post(`/apps-notifications?page=${page}`, {
        key_s: "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9",
        currency: selectedCurrency,
      })
      .then((res) => {
        if (res.data.status === "success") {
          setIncome(res.data.data || []);
          setPagination(res.data.pagination);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchIncome(1);
  }, []);

const [selectedNotification, setSelectedNotification] = useState(null);
const [detailsLoading, setDetailsLoading] = useState(false);
const [showModal, setShowModal] = useState(false);

const fetchNotificationDetails = async (id) => {
  console.log("Clicked ID:", id);

  try {
    const selectedCurrency = localStorage.getItem("selectedCurrency");

    const res = await axios.post(
      `/apps-notification-details/${id}`,
      {
        key_s: "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9",
        currency: selectedCurrency,
      }
    );

    console.log("API Response:", res.data);

    if (res.data.status === "success") {
      setSelectedNotification(res.data.data);
      setShowModal(true);
    }
  } catch (error) {
    console.log(error);
  }
};

{showModal && (
  <div
    className="notification-modal-overlay"
    onClick={() => setShowModal(false)}
  >
    <div
      className="notification-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-header-custom">
        <h5>
          <i className="fas fa-bell me-2"></i>
          Notification Details
        </h5>

        <button
          className="btn btn-danger btn-sm"
          onClick={() => setShowModal(false)}
        >
          ×
        </button>
      </div>

      {detailsLoading ? (
        <div className="text-center p-4">
          Loading...
        </div>
      ) : (
        <>
          <h4 className="mb-3">
            {selectedNotification?.title}
          </h4>

          <small className="text-muted d-block mb-3">
            {selectedNotification?.date}
          </small>

          <div
            style={{
              background: "#f8f9fa",
              padding: "15px",
              borderRadius: "10px",
              whiteSpace: "pre-wrap",
            }}
          >
            {selectedNotification?.details}
          </div>
        </>
      )}
    </div>
  </div>
)}

  /* PAGINATION */

  const getPageNumbers = () => {
    const total = pagination.last_page;
    const current = pagination.current_page;
    const windowSize = 5;

    let start = Math.max(1, current - Math.floor(windowSize / 2));
    let end = start + windowSize - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - windowSize + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);

    return pages;
  };

  return (
    <div className="col-12">

      <style>
        {`

        .notification-card{
            display:flex;
            align-items:center;
            padding:14px;
            margin-bottom:12px;
            border-radius:12px;
            background:#f8f9fa;
            box-shadow:0 3px 8px rgba(0,0,0,0.08);
        }


        .notification-html-content{
            color:#333;
            line-height:1.8;
            font-size:15px;
        }

        .notification-html-content h1,
        .notification-html-content h2,
        .notification-html-content h3,
        .notification-html-content h4,
        .notification-html-content h5{
            color:#0d6efd;
            margin-bottom:15px;
            font-weight:700;
        }

        .notification-html-content p{
            margin-bottom:15px;
        }

        .notification-html-content img{
            max-width:100%;
            border-radius:12px;
            margin:15px 0;
        }

        .notification-html-content table{
            width:100%;
            border-collapse:collapse;
            margin-top:15px;
        }

        .notification-html-content table td,
        .notification-html-content table th{
            border:1px solid #ddd;
            padding:10px;
        }

        .notification-html-content ul,
        .notification-html-content ol{
            padding-left:20px;
        }

        .notification-html-content a{
            color:#0d6efd;
            text-decoration:none;
            font-weight:600;
        }

        .notification-icon{
            width:45px;
            height:45px;
            border-radius:50%;
            display:flex;
            align-items:center;
            justify-content:center;
            margin-right:12px;
            background:#0d6efd;
            color:white;
            font-size:18px;
        }

        /* UNSEEN ICON ANIMATION */

        .unseen .notification-icon{
            animation:bellmove 1s infinite;
            background:#ff9800;
        }

        @keyframes bellmove{
            0%{transform:rotate(0deg)}
            25%{transform:rotate(10deg)}
            50%{transform:rotate(-10deg)}
            75%{transform:rotate(10deg)}
            100%{transform:rotate(0deg)}
        }

        .seen{
            opacity:0.7;
        }


      .notification-modal-overlay{
          position:fixed;
          top:0;
          left:0;
          width:100%;
          height:100%;
          background:rgba(0,0,0,.5);
          display:flex;
          justify-content:center;
          align-items:center;
          z-index:99999;
      }

      .notification-modal{
          background:#fff;
          width:95%;
          max-width:500px;
          border-radius:15px;
          padding:20px;
          animation:popup .3s ease;
      }

      @keyframes popup{
          from{
              opacity:0;
              transform:scale(.8);
          }
          to{
              opacity:1;
              transform:scale(1);
          }
      }

      .modal-header-custom{
          display:flex;
          justify-content:space-between;
          align-items:center;
          margin-bottom:15px;
      }

        `}
      </style>

      <div className="card">

        <div className="card-header">
          <h4 className="card-title">
            <i className="fas fa-bell me-2"></i>
            Notifications
          </h4>
        </div>

        <div className="card-body">

          {loading ? (
            <div className="text-center p-4">
              Loading...
            </div>
          ) : income.length > 0 ? (
            income.map((row, index) => {

              const isUnseen = row.status;



return (
<>
  <div className="col-12">


                             
                <div
                  key={row.id}
                  className={`notification-card ${isUnseen ? "" : "seen"} ${isUnseen ? "unseen" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => fetchNotificationDetails(row.id)}
                >
                  {/* ICON */}

                  <div className="notification-icon">
                    <i className="fas fa-bell"></i>
                  </div>

                  {/* TEXT */}

                  <div style={{ flex: 1 }}>

                    <div style={{ fontWeight: "600", fontSize: "14px" }}>
                      {row.title}
                    </div>

                    <div style={{ fontSize: "11px", color: "#888" }}>
                      {row.date}
                    </div>

                  </div>

                  {/* STATUS */}

                  <div>

                    {isUnseen ? (
                      <span className="badge bg-secondary">New</span>
                    ) : (
                      <span className="badge bg-danger">Seen</span>
                    )}

                  </div>

                </div>

  </div>

  {showModal && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,.5)",
        zIndex: 999999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >


      <div
        style={{
          width: "500px",
          background: "#fff",
          padding: "20px",
          borderRadius: "10px"
        }}
      >
        <h3>{selectedNotification?.title}</h3>
        <hr></hr>

        <div
          dangerouslySetInnerHTML={{
            __html:
              selectedNotification?.details || ""
          }}
        />
        <hr></hr>
        <p>Create Time: {selectedNotification?.date}</p>

        <button
          className="btn btn-danger mt-3"
          onClick={() => setShowModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  )}
</>
);





            })
          ) : (
            <div className="text-center p-4">
              No Notification
            </div>
          )}

          {/* PAGINATION */}

          <div className="d-flex justify-content-between align-items-center mt-4">

            <button
              className="btn btn-sm btn-light"
              disabled={pagination.current_page === 1}
              onClick={() =>
                fetchIncome(pagination.current_page - 1)
              }
            >
              ‹
            </button>

            <div>

              {getPageNumbers().map((page) => (
                <button
                  key={page}
                  className={`btn btn-sm me-1 ${
                    pagination.current_page === page
                      ? "btn-primary"
                      : "btn-light"
                  }`}
                  onClick={() => fetchIncome(page)}
                >
                  {page}
                </button>
              ))}

            </div>

            <button
              className="btn btn-sm btn-light"
              disabled={
                pagination.current_page === pagination.last_page
              }
              onClick={() =>
                fetchIncome(pagination.current_page + 1)
              }
            >
              ›
            </button>

          </div>

        </div>
      </div>
    </div>
  );
};

export default BasicDatatable;